function bytesToSize(bytes, decimals = 2) {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  const parsedFloat = parseFloat((bytes / k ** i).toFixed(dm)).toString();

  return parsedFloat.concat(` ${sizes[i]}`);
}

export default bytesToSize;
